import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'

interface fieldInterface {
    fieldLabel: string
    children: React.ReactNode
    labelPosition?: string
    extraStyle?: any
    enhanced?: boolean
}

export const Field = (props: fieldInterface) => {
    const { children, fieldLabel, labelPosition, extraStyle, enhanced = false } = props
    return (
        <div style={extraStyle} className={`${styles.field} ${enhanced ? styles.enhanced : ''}`}>
            <label className={`${labelPosition ? styles[labelPosition] : ''} ${enhanced ? styles.enhancedLabel : ''}`}>
                {fieldLabel}
            </label>
            {children}
        </div>
    )
}
